import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faFacebookF, faLinkedin } from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-[#0B132A] to-black text-gray-300">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 md:px-10 xl:px-20 pt-16 md:pt-20 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-[2fr,3fr] gap-12 md:gap-10">
          <div className="md:pr-12">
            <img
              src="/logo/logo-footer.svg"
              alt="AMS logo"
              className="w-[160px] md:w-[180px] h-auto object-contain"
              loading="lazy"
              decoding="async"
            />
            <p className="mt-4 text-sm leading-relaxed text-gray-400 max-w-[42ch]">
              Ruko Citywalk, Jl. Pondok Cabe No. 08, Pondok Cabe Udik, Pamulang,
              Tangerang Selatan, Banten 15418
            </p>
            <p className="mt-3 font-medium text-sm break-all">
              <a
                href="mailto:support@angkasamultimediasolusi.com"
                className="hover:text-emerald-400 transition-colors"
              >
                support@angkasamultimediasolusi.com
              </a>
            </p>
            <p className="mt-1 font-medium text-sm">
              <a
                href="tel:+6289507085550"
                className="hover:text-emerald-400 transition-colors"
              >
                (+62) 895-0708-5550
              </a>
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:gap-10 md:grid-cols-4 md:gap-8">
            <div className="pt-2 md:pt-0 md:pl-5 md:border-l md:border-gray-700/40">
              <h4 className="text-xs uppercase tracking-wider font-semibold text-gray-400 mb-4">
                Sosial Media
              </h4>
              <div className="flex items-center gap-2">
                <a
                  href="https://www.instagram.com/angkasamultimediasolusi/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="h-10 w-10 flex items-center justify-center rounded-full bg-gray-800 hover:bg-emerald-500 transition-colors"
                  aria-label="Instagram"
                >
                  <FontAwesomeIcon icon={faInstagram} className="text-lg text-white" />
                </a>
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="h-10 w-10 flex items-center justify-center rounded-full bg-gray-800 hover:bg-emerald-500 transition-colors"
                  aria-label="Facebook"
                >
                  <FontAwesomeIcon icon={faFacebookF} className="text-lg text-white" />
                </a>
                <a
                  href="https://www.linkedin.com/company/angkasa-multimedia-solusi/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="h-10 w-10 flex items-center justify-center rounded-full bg-gray-800 hover:bg-emerald-500 transition-colors"
                  aria-label="Linkedin"
                >
                  <FontAwesomeIcon icon={faLinkedin} className="text-lg text-white" />
                </a>
              </div>
            </div>

            <div className="pt-2 md:pt-0 md:pl-5 md:border-l md:border-gray-700/40">
              <h4 className="text-xs uppercase tracking-wider font-semibold text-gray-400 mb-4">
                Navigasi
              </h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/" className="hover:text-emerald-400 transition-colors">Home</Link></li>
                <li><Link to="/gallery" className="hover:text-emerald-400 transition-colors">Project</Link></li>
                <li><Link to="/services" className="hover:text-emerald-400 transition-colors">Service</Link></li>
                <li><Link to="/product" className="hover:text-emerald-400 transition-colors">Brands</Link></li>
                <li><Link to="/articles" className="hover:text-emerald-400 transition-colors">Articles</Link></li>
              </ul>
            </div>

            <div className="pt-2 md:pt-0 md:pl-5 md:border-l md:border-gray-700/40">
              <h4 className="text-xs uppercase tracking-wider font-semibold text-gray-400 mb-4">
                Bantuan
              </h4>
              <ul className="space-y-2 text-sm">
                <li>
                  <a
                    href="https://wa.me/6289507085550"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-emerald-400 transition-colors"
                    aria-label="Contact Us via WhatsApp"
                  >
                    Contact Us
                  </a>
                </li>
                <li><Link to="/request" className="hover:text-emerald-400 transition-colors">Request</Link></li>
              </ul>
            </div>

            <div className="pt-2 md:pt-0 md:pl-5 md:border-l md:border-gray-700/40">
              <h4 className="text-xs uppercase tracking-wider font-semibold text-gray-400 mb-4">
                Solusi
              </h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/solutions/classroom" className="hover:text-emerald-400 transition-colors">Smart Classroom</Link></li>
                <li><Link to="/solutions/meetingroom" className="hover:text-emerald-400 transition-colors">Smart Meetingroom</Link></li>
                <li><Link to="/solutions/auditorium" className="hover:text-emerald-400 transition-colors">Smart Auditorium</Link></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-700/40 mt-10 pt-6 text-center md:text-left">
          <p className="text-xs sm:text-sm text-gray-500">
            © {year} Angkasa Multimedia Solusi. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
